module.exports = __webpack_public_path__ + "img/turanza6_all_banner.1d9c1fa9.jpg";